import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=632916a6&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"
import style0 from "./blackList.vue?vue&type=style&index=0&id=632916a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632916a6",
  null
  
)

export default component.exports